<ng-container [formGroup]="form">
  <mat-form-field *ngIf="control"
                  [matTooltip]="tooltip"
                  [attr.data-test-id]="config.testId"
                  class="form-input m-0">
    <mat-label>{{config.title}}</mat-label>
    <input [formControlName]="controlName"
           [matAutocomplete]="auto"
           (focus)="focus()"
           [maxLength]="config.maxLength"
           [placeholder]="config.placeholder"
           [attr.aria-label]="controlName"
           type="text"
           class="input"
           matInput
           autocomplete="off"
           autoScrollTarget>
    <button
      *ngIf="!control?.value && !autocompleteListLoading && (!config.hideArrowIfListEmpty || autocompleteList?.length)"
      [disabled]="control?.disabled"
      class="p-0"
      mat-button
      matSuffix
      mat-icon-button>
      <mat-icon matSuffix>arrow_drop_down</mat-icon>
    </button>

    <button *ngIf="control?.value && !autocompleteListLoading"
            (click)="clearField(control, $event, '')"
            class="p-0"
            mat-button
            matSuffix
            mat-icon-button
            aria-label="Clear">
      <mat-icon>close</mat-icon>
    </button>

    <button *ngIf="autocompleteListLoading"
            class="p-0 transform"
            mat-button
            matSuffix
            mat-icon-button
            [disabled]="true">
      <mat-spinner [diameter]="19.5" class="form-field-spinner"></mat-spinner>
    </button>


    <mat-autocomplete #auto="matAutocomplete"
                      [displayWith]="config.displayWithCallback"
    >
      <mat-option *ngIf="autocompleteListEmpty"
                  [disabled]="true">{{config.emptyListNote ?? 'Немає співпадінь'}}
      </mat-option>
      <mat-option *ngFor="let listItem of autocompleteList
      | filterBy : config.listOptionName
      : (filterQuery$ | async)"
                  [value]="listItem">
        {{listItem[config.listOptionName]}}
      </mat-option>
    </mat-autocomplete>
    <mat-error>{{getError(control, config.errors)}}</mat-error>
  </mat-form-field>
</ng-container>

